export const endpoint = process.env.GATSBY_API_URL || 'http://localhost:3010';
